import React, { forwardRef, ReactElement } from 'react'
import { Icon, IconBase, IconWeight } from '@phosphor-icons/react'

const getWeights = (color?: string) => {
    const regular: ReactElement = (
        <svg width="256" height="256" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5 4.85313C11.8662 3.20563 10.5356 2 8 2C4 2 3 5 3 8C3 11 4 14 8 14C11 14 12.5 12 12.5 10.5C12.5 6.5 6 6.5 6 9.5C6 12 10.5 12 10.5 8C10.5 4.5 7 4.5 6 6"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
    const fill: ReactElement = (
        <svg width="256" height="256" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_14631_22782)">
                <path
                    d="M8.66375 8C8.93982 8.00005 9.21483 8.03427 9.4825 8.10188C9.44688 8.615 9.27375 9.03938 8.97563 9.3275C8.69758 9.5978 8.32528 9.74931 7.9375 9.75C7.19562 9.75 7 9.27625 7 8.99562C7 8.3125 7.8625 8 8.66375 8ZM14 8C14 12.07 11.7569 14.5 8 14.5C4.24312 14.5 2 12.07 2 8C2 3.93 4.24312 1.5 8 1.5C11.7569 1.5 14 3.93 14 8ZM4.5 8C4.5 5.30813 5.645 4 8 4C9.64625 4 10.6875 4.63 11.1756 5.92688C11.2225 6.0512 11.3169 6.15179 11.438 6.20653C11.5591 6.26126 11.6969 6.26566 11.8212 6.21875C11.9456 6.17184 12.0462 6.07746 12.1009 5.95639C12.1556 5.83531 12.16 5.69744 12.1131 5.57312C11.3062 3.44625 9.43125 3 8 3C6.36875 3 5.155 3.54375 4.3925 4.61625C3.8 5.44938 3.5 6.5875 3.5 8C3.5 9.4125 3.8 10.5506 4.3925 11.3837C5.155 12.4563 6.36875 13 8 13C9.52812 13 10.4888 12.45 11.0256 11.9888C11.6981 11.4106 12.1 10.6206 12.1 9.875C12.1 8.98125 11.6881 8.20062 10.94 7.67688C10.7862 7.56985 10.6238 7.47577 10.4544 7.39563C10.3238 6.48 9.82937 5.78625 9.05812 5.45375C8.15187 5.0625 7 5.24563 6.32562 5.88688C6.22932 5.97804 6.17317 6.10373 6.16954 6.2363C6.16591 6.36887 6.21508 6.49744 6.30625 6.59375C6.39742 6.69006 6.52311 6.7462 6.65567 6.74984C6.78824 6.75347 6.91682 6.70429 7.01312 6.61312C7.3525 6.29187 8.0625 6.11312 8.66313 6.3725C8.96909 6.5018 9.2112 6.74728 9.33625 7.055C9.11382 7.01973 8.88896 7.00197 8.66375 7.00187C7.09562 7 6 7.82187 6 8.99562C6 10.0125 6.8125 10.75 7.9375 10.75C8.5852 10.7483 9.20699 10.4954 9.67188 10.0444C9.96562 9.7575 10.3038 9.28188 10.4325 8.54438C10.6435 8.69528 10.8145 8.8953 10.9308 9.12715C11.0471 9.35899 11.1052 9.61567 11.1 9.875C11.1 10.7319 10.115 12 8 12C5.645 12 4.5 10.6919 4.5 8Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_14631_22782">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
    return new Map<IconWeight, ReactElement>([
        ['regular', regular],
        ['fill', fill],
    ])
}

/**
 * Phosphor custom icon based on https://github.com/phosphor-icons/react#custom-icons
 */
const ThreadsLogo: Icon = forwardRef((props, ref) => {
    return <IconBase ref={ref} {...props} weights={getWeights(props.color)} fill="None" />
})

ThreadsLogo.displayName = 'ThreadsLogo'

export default ThreadsLogo
